import axios from 'axios';

const params = {
  custom_task_ids: 'false',
  team_id: '9004005345',
};

const config = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: 'pk_56592384_WHIN17CPPG6YAST8E7DG5KFNYQ1S5BPM',
  },
};

export const sendContactForm = (
  email: string,
  pageTag: string,
  name?: string,
  message?: string,
) => {
  const query = new URLSearchParams(params).toString();

  const listId = '900400314213';

  const taskName = name ? `${name} (${email})` : email;
  const description = message ? `${message}\n\n${pageTag}` : pageTag;

  const data = {
    name: taskName,
    description,
    assignees: [],
    tags: ['website', pageTag],
  };

  return axios.post(`https://api.clickup.com/api/v2/list/${listId}/task?${query}`, data, config);
};
